<template>
  <v-popover class="v-select" :trigger="trigger" ref="input">
    <div slot="trigger" class="v-select-selected" :placeholder="placeholder" ref="selected">
      <div class="v-select-selected-item" :label="o[optionLabel]" @click="selectedOption(o)" v-for="(o,i) in selectedOptions" :key="i">
				<slot name="selected" :selected="o" />
			</div>
    </div>
    <div slot="trigger" class="v-select-allow">
      <v-icon type="v-icon-select-allow"/>
    </div>
    <div class="v-select-content" :loading="loading">
      <div class="v-select-head">
        <slot name="head"/>
      </div>
      <v-pagination class="v-select-options" :nodata="!list.length&&nodataText" @scroll-bottom="scrollBottom">
        <div class="v-select-option" :class="{active:includes(o)}" :label="o[optionLabel]" :disabled="o.disabled" @click="select(o)" v-for="(o,i) in list" :key="i">
          <slot name="option" :option="o"/>
        </div>
      </v-pagination>
      <div class="v-select-foot">
        <slot name="foot"/>
      </div>
    </div>
  </v-popover>
</template>

<script>
export default {
  props: {
    value: {
      default: null
    },
    options: {
      default() {
        return [];
      }
    },
    trigger: {
      default: "click"
    },
    optionLabel: {
      default: "label"
    },
    optionValue: {
      default: "value"
    },
    placeholder: {
      default: null
    },
    nodataText: {
      default: "暂无数据"
    }
  },
  data() {
    return {
      loading: false,
      active: false,
      selectedOptions: []
    };
  },
  computed: {
    join() {
      return "join" in this.$attrs ? this.$attrs.join || "," : "";
    },
    multiple() {
      return this.$attrs.multiple != null;
    },
    keepActive() {
      return "keep-active" in this.$attrs;
    },
    clearable() {
      return "clearable" in this.$attrs;
    },
    list() {
      return this.options.map((o, i) => {
        let value = (o =
          o instanceof Object
            ? o
            : {
                [this.optionLabel]: o,
                [this.optionValue]: i
              })[this.optionValue];
        return Object.assign(o, {
          [this.optionLabel]: String(o[this.optionLabel]),
          [this.optionValue]: this.join ? String(value) : value
        });
      });
    }
  },
  watch: {
    ["options.length"](value) {
      this.list.forEach(o =>
        Object.assign(this.selectedOptions[this.indexOf(o)] || {}, o)
      );
    }
  },
  methods: {
    indexOf(o) {
      return this.selectedOptions.reduce(
        (p, x, i) => (x[this.optionValue] === o[this.optionValue] ? i : p),
        -1
      );
    },
    includes(o) {
      return this.indexOf(o) !== -1;
    },
    select(o) {
      let value = o[this.optionValue],
        index = this.indexOf(o);
      if (this.multiple) {
        index == -1
          ? this.selectedOptions.push(o)
          : this.selectedOptions.splice(index, 1);
        let values = this.selectedOptions.map(x => x[this.optionValue]);
        value = this.join ? values.join(this.join) : values;
      } else {
        if (this.clearable && index == 0) {
          value = null;
          this.selectedOptions = [];
        } else {
          this.selectedOptions = [o];
        }
      }
      this.$emit("input", value);
      this.selectOption(o);
    },
    selectOption(o) {
      this.$emit("select", o, this);
      this.multiple ||
        (this.keepActive || !this.selectedOptions.includes(o)) ||
        this.$refs.input.close();
    },
    selectedOption(o) {
      this.$emit("selected", o, this);
    },
    scrollBottom() {
      if ("load-next" in this.$listeners) this.loading = true;
      this.$emit("load-next", () => (this.loading = false));
    }
  },
  mounted() {
    let value = this.value;
    if (this.multiple) {
      this.selectedOptions = (value instanceof Array
        ? value
        : (this.join ? String(value).split(this.join) : [value]).filter(o => o)
      ).reduce((p, v) => {
        return (
          p.push(
            this.list.filter(o => o[this.optionValue] === v)[0] || {
              [this.optionLabel]: `未知项[${v}]`,
              [this.optionValue]: v
            }
          ),
          p
        );
      }, []);
    } else {
      this.selectedOptions = (value = value instanceof Array ? null : value)
        ? [
            this.list.filter(o => o[this.optionValue] === value)[0] || {
              [this.optionLabel]: `未知项[${value}]`,
              [this.optionValue]: value
            }
          ]
        : [];
    }
    this.$emit("loaded", () => (this.loading = false));
  }
};
</script>

<style lang="less">
.v-select {
  > .v-popover-trigger {
    > .v-select-selected {
      width: 160px;
      outline: none;
      cursor: pointer;
      font-size: 14px;
      overflow: hidden;
      text-align: left;
      line-height: 26px;
      border-radius: 4px;
      word-break: break-all;
      word-break: break-word;
      caret-color: transparent;
      padding: 2px 22px 2px 6px;
      border: 1px solid #dddddd;
      background-color: #fcfcfc;
      transition: border 300ms;
      &:empty {
        &::before {
          color: #999999;
          content: "请选择";
        }
        &[placeholder] {
          padding-left: 6px;
          &::before {
            content: attr(placeholder);
          }
        }
      }
      > .v-select-selected-item {
        display: flex;
        &:empty[label]::before {
          content: attr(label);
        }
      }
    }
    > .v-select-allow {
      top: 0px;
      right: 0px;
      cursor: pointer;
      color: #999999;
      position: absolute;
      margin: 5px 6px 5px 0px;
      transition: transform 300ms;
    }
  }
  > .v-popover-content {
    > .v-popover-pagination {
      display: flex;
      > .v-select-content {
        flex: 1;
        display: flex;
        flex-direction: column;
        > .v-select-head,
        > .v-select-foot {
          z-index: -1;
          padding: 6px;
          position: relative;
        }
        > .v-select-head {
          border-bottom: 1px solid #eeeeee;
        }
        > .v-select-foot {
          border-top: 1px solid #eeeeee;
        }
        > .v-select-head:empty,
        > .v-select-foot:empty {
          display: none;
        }
        > .v-select-options {
          min-height: 30px;
          > .v-select-option {
            margin: 1px 0px;
            cursor: pointer;
            white-space: nowrap;
            transition: 300ms;
            &:not(:last-child) {
              border-bottom: 1px solid #ffffff;
            }
            &:hover {
              background-color: #eeeeee;
            }
            &:empty[label] {
              &::before {
                display: block;
                padding: 4px 10px;
                content: attr(label);
              }
            }
            &.active {
              color: #ffffff;
              background-color: #41b883;
            }
          }
        }
      }
    }
  }
  &.active {
    > .v-popover-trigger {
      > .v-select-selected {
        border: 1px solid #41b883;
      }
      > .v-select-allow {
        transform: rotateZ(180deg);
      }
    }
  }
  &[multiple] {
    > .v-popover-trigger {
      > .v-select-selected {
        line-height: 26px;
        padding: 2px 26px 2px 2px;
        &:empty {
          padding: 2px 22px 2px 6px;
        }
        > .v-select-selected-item {
          display: inline-block;
          &:empty[label]::before {
            margin: 2px;
            display: block;
            color: #ffffff;
            padding: 1px 5px;
            line-height: 20px;
            border-radius: 4px;
            background-color: #41b883;
          }
        }
      }
    }
  }
  &:not([multiple]) {
    > .v-popover-trigger {
      > .v-select-selected {
        > .v-select-selected-item {
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/vue-ext/components/popover/select/index.vue